// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { wemixTestnet as _wemixTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the wemixTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 1112
 * Chain Name: WEMIX Testnet
 * Default Block Explorer: https://testnet.wemixscan.com
 * Default RPC URL: https://api.test.wemix.com
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { wemixTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: wemixTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const wemixTestnet = createCommon({
	..._wemixTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
